
<div mat-dialog-content class="scrollableMatTabContent">
  <div style="padding-bottom: 10px;">
    <mat-tab-group style="max-height: 60vh;" dynamicHeight mat-align-tabs="start" mat-stretch-tabs="false" animationDuration="1000ms" class="{{isTransactional === false? ' hideTabs' : ''}}">
      <mat-tab label="{{'MarketMonitor.monitor.lblContributions' | translate}}">
        <div class="scrollableTable mat-elevation-z6" style="width: 100%;" #TABLE>
          <table #table #sortCont="matSort" mat-table [dataSource]="dataSource" matSort matSortDisableClear matSortDirection="desc">
            @for (column of displayColumnsDynamic; track column) {
            <ng-container matColumnDef="{{column}}">
              <th mat-header-cell *matHeaderCellDef class="tableFilterFont"
                  [style.width]="50/displayColumnsDynamic.length + '%'">
                {{column}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{OnDataBound(element, column)}}
              </td>
            </ng-container>
            }
            <ng-container matColumnDef="contributed">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 10%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thContributed' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.contributed}}
              </td>
            </ng-container>
            <ng-container matColumnDef="contributor">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 20%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thContributor' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" (click)="OnClickName(element.contributor)" class="clickable">
                <u>{{element.contributor.firstName}} {{element.contributor.lastName}}</u>
              </td>
            </ng-container>
            <ng-container matColumnDef="approver">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 20%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thApprover' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" (click)="OnClickName(element.approver)" class="clickable">
                <u>{{element.approver.firstName}} {{element.approver.lastName}}</u>
              </td>
            </ng-container>
            <ng-container matColumnDef="loading">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                {{'tblLoading' | translate }}...
              </th>
            </ng-container>
            <ng-container matColumnDef="noData">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                {{'MarketMonitor.tblNoData' | translate}}...
              </th>
            </ng-container>
            <tr style="background-color: #e3e3e3;" mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSource!=null}"></tr>
            <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':(dataSource!=null && contRecordsLength != 0) || isLoading === true}"></tr>
          </table>
        </div>
      </mat-tab>
      <mat-tab label="{{'MarketMonitor.monitor.lblTransactions' | translate}}" [ngStyle]="{'display': isTransactional === true ? 'inline' : 'none' }">
        <div class="scrollableTable mat-elevation-z6">
          <table #sortTrans="matSort" mat-table [dataSource]="dataSourceTrans" matSort>
            <ng-container matColumnDef="tradeDate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 100px;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thTradeDate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.tradeDate | date:"d MMM yyyy"}}
              </td>
            </ng-container>
            <ng-container matColumnDef="instrumentCode">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thTenor' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" [innerHTML]="element.instrumentCode"></td>
            </ng-container>
            <ng-container matColumnDef="currency">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thCurrency' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.currency}}
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thStatus' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.status}}
              </td>
            </ng-container>
            <ng-container matColumnDef="cpSector">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thCpSector' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.cpSector}}
              </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thType' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.type}}
              </td>
            </ng-container>
            <ng-container matColumnDef="identifier">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thIdentifier' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.identifier}}
              </td>
            </ng-container>
            <ng-container matColumnDef="contributed">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thContributed' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.contributed | date:"h:mm:ss a"}}
              </td>
            </ng-container>
            <ng-container matColumnDef="settlementDate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thSettlementDate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.settlementDate | date:"d MMM yyyy"}}
              </td>
            </ng-container>
            <ng-container matColumnDef="maturityDate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thMaturityDate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.maturityDate | date:"d MMM yyyy"}}
              </td>
            </ng-container>
            <ng-container matColumnDef="nominalAmount">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thNomAmount' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{FormatNumber(element.nominalAmount)}}
              </td>
            </ng-container>
            <ng-container matColumnDef="rate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thRate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.rate}}
              </td>
            </ng-container>
            <ng-container matColumnDef="exchangeRate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thExchangeRate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.exchangeRate}}
              </td>
            </ng-container>
            <ng-container matColumnDef="forwardRate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thForwardRate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.forwardRate}}
              </td>
            </ng-container>
            <ng-container matColumnDef="level">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thLevel' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.level}}
              </td>
            </ng-container>
            <ng-container matColumnDef="levelSubmissionRate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thLSubRate' | translate}}
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.levelSubmissionRate}}
              </td>
            </ng-container>
            <ng-container matColumnDef="anomalous">
              <th mat-header-cell mat-sort-header *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thAnomalous' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" class="{{(element.anomalous.anomalous === true ? 'clickable' : '')}}" (click)="OnClickAnomalous(element.anomalous)">
                <mat-label class="{{(element.anomalous.anomalous === true ? 'underlined' : '')}}">{{(element.anomalous.anomalous ? 'No' : 'Yes')}}</mat-label>
              </td>
            </ng-container>
            <ng-container matColumnDef="exclude">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;" class="tableFilterFont stickyRightHeader">
                {{'MarketMonitor.monitor.thExclude' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" class="stickyRightColumn">
                <mat-checkbox (change)="OnChangeExclude(element, element.exOp1, $event)" color="primary" [checked]="(element.exOp1.userId !== '' ? true : false)" [disabled]="!element.exOp1.canEnableChkbx"></mat-checkbox>
                &nbsp;&nbsp;
                <mat-checkbox (change)="OnChangeExclude(element, element.exOp2, $event)" color="primary" [checked]="(element.exOp2.userId !== '' ? true : false)" [disabled]="!element.exOp2.canEnableChkbx"></mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="loading">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                {{'tblLoading' | translate}}...
              </th>
            </ng-container>
            <ng-container matColumnDef="noData">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                {{'MarketMonitor.tblNoData' | translate}}...
              </th>
            </ng-container>
            <tr style="background-color: #e3e3e3;" mat-header-row *matHeaderRowDef="displayColumnsTrans; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnsTrans;"></tr>
            <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceTrans!=null}"></tr>
            <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':(dataSourceTrans!=null && transRecordsLength != 0) || isLoading === true}"></tr>
          </table>
        </div>
      </mat-tab>
      <mat-tab label="{{'MarketMonitor.monitor.lblLogs' | translate}}" [ngStyle]="{'display': isTransactional === true ? 'inline' : 'none' }">
        <div class="scrollableTable mat-elevation-z6" style="width: 100%;">
          <table mat-table [dataSource]="dataSourceLogs">
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef style="width: 5%;"></th>
              <td mat-cell *matCellDef="let element" style="vertical-align: top;">
                <mat-icon color="{{ element.status }}">{{ element.icon }}</mat-icon>
              </td>
            </ng-container>
            <ng-container matColumnDef="event">
              <th mat-header-cell *matHeaderCellDef style="width: 15%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thEvent' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" style="vertical-align: top;">
                {{element.event}}
              </td>
            </ng-container>
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef class="tableFilterFont">
                {{'MarketMonitor.monitor.thDescription' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" [innerHtml]="element.description" style="vertical-align: top;"></td>
            </ng-container>
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef style="width: 15%;" class="tableFilterFont">
                {{'MarketMonitor.monitor.thTime' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" style="vertical-align: top;">
                {{element.time}}
              </td>
            </ng-container>
            <ng-container matColumnDef="loading">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                {{'tblLoading' | translate}}...
              </th>
            </ng-container>
            <ng-container matColumnDef="noData">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                {{'MarketMonitor.tblNoData' | translate}}...
              </th>
            </ng-container>
            <tr style="background-color: #e3e3e3;" mat-header-row *matHeaderRowDef="displayColumnsLogs; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnsLogs;"></tr>
            <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceLogs!=null}"></tr>
            <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':(dataSourceLogs!=null && logsRecordsLength != 0) || isLoading === true}"></tr>
          </table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
@if (isTransactional === true) {
<div class="row">
  <div class="col-4">
    <div class="row" style="margin: 0;">
      @if (service.currentUser.isReadOnly === false) {
      <mat-slide-toggle [(ngModel)]="allowTransactions" [ngModelOptions]="{standalone: true}" color="primary" (ngModelChange)="EnableDisableTransactionAllow('transaction')">
        {{'MarketMonitor.monitor.lblAllowTrans' | translate}}
      </mat-slide-toggle>
      }
    </div>
    <div class="row" style="margin: 0;">
      @if (service.currentUser.isReadOnly === false) {
      <mat-slide-toggle [(ngModel)]="allowSubmissions" [ngModelOptions]="{standalone: true}" color="primary" (ngModelChange)="EnableDisableTransactionAllow('submission')">
        {{'MarketMonitor.monitor.lblAllowSub' | translate}}
      </mat-slide-toggle>
      }
    </div>
  </div>
  <div class="col-8 text-right" style="display: flex; align-items: center; justify-content: end;">
    <mat-label> {{'MarketMonitor.monitor.lblAccepted' | translate}}: {{transactionLogDetails.accepted}}</mat-label>
    <mat-label class="statusLabel"> {{'MarketMonitor.monitor.lblPartial' | translate}}: {{transactionLogDetails.partial}}</mat-label>
    <mat-label class="statusLabel"> {{'MarketMonitor.monitor.lblRejected' | translate}}: {{transactionLogDetails.rejected}}</mat-label>
    <mat-label class="statusLabel"> {{'MarketMonitor.monitor.lblInvalid' | translate}}: {{transactionLogDetails.invalid}}</mat-label>
    <mat-label class="statusLabel"> {{'MarketMonitor.monitor.lblCorrupt' | translate}}: {{transactionLogDetails.corrupt}}</mat-label>
  </div>
</div>
}
<div mat-dialog-actions>
  <button style="float: right;" mat-raised-button color="secondary" (click)="OnCancel()">{{'btnClose' | translate}}</button>
</div>
